import { parse } from "cookie"

export type CookieSameSite = "Strict" | "Lax"

export interface CookieOptions {
  maxAgeSeconds?: number
  sameSite?: CookieSameSite
}

const PATH = "/"

// localhost counts as a secure context, so this is about http:// deployments and
// nothing else; a Secure cookie on a plain-http host is dropped silently.
const isSecureContext = (): boolean => process.env.NODE_ENV === "production" || window.location.protocol === "https:"

const attributes = ({ maxAgeSeconds, sameSite = "Lax" }: CookieOptions): string[] => [
  `path=${PATH}`,
  `SameSite=${sameSite}`,
  ...(isSecureContext() ? ["Secure"] : []),
  ...(maxAgeSeconds === undefined ? [] : [`max-age=${maxAgeSeconds}`]),
]

export const readCookie = (name: string): string | null => {
  if (typeof window === "undefined") return null
  return parse(document.cookie)[name] || null
}

export const setCookie = (name: string, value: string, options: CookieOptions = {}): void => {
  if (typeof window === "undefined") return
  document.cookie = [`${name}=${encodeURIComponent(value)}`, ...attributes(options)].join("; ")
}

// max-age=0 rather than an epoch expires: both delete, and one of them is the
// same attribute the setters already use.
export const deleteCookie = (name: string, options: CookieOptions = {}): void => {
  if (typeof window === "undefined") return
  document.cookie = [`${name}=`, ...attributes({ ...options, maxAgeSeconds: 0 })].join("; ")
}
